// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PDPA_wrapper__aDGgM","content":"PDPA_content__3Q3rN","link":"PDPA_link__9oa7V","button":"PDPA_button__H_RUe"};